import React from 'react';
import { SparklesIcon, UsersIcon, CpuIcon } from 'lucide-react';
import { FadeUp } from '../motion/FadeUp';
const PILLARS = [{
  icon: SparklesIcon,
  title: 'Innovation',
  text: 'Purposeful ideas that create meaningful, lasting value.'
}, {
  icon: UsersIcon,
  title: 'Community',
  text: 'Strengthening human connection beyond the screen.'
}, {
  icon: CpuIcon,
  title: 'Technology',
  text: 'Craft that enhances everyday life, quietly and well.'
}];
export function About() {
  return <section id="about" className="w-full bg-white px-6 py-28 md:py-36 lg:px-8" data-id="element-49" data-mp="627i7ejztdmi">
      <div className="mx-auto max-w-6xl" data-id="element-50" data-mp="jt2qopqkxspk">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-51" data-mp="jtvrzb6rrq0b">
          <div data-id="element-52" data-mp="f0j638th5xb9">
            <FadeUp data-id="element-53" data-mp="f01ckjy75x71">
              <p className="text-xs font-medium uppercase tracking-[0.24em] text-vermillion" data-id="element-54" data-mp="ezhqqs5feonq">
                About Haerumbah
              </p>
            </FadeUp>
            <FadeUp delay={0.08} data-id="element-55" data-mp="3jf137zvizjsk">
              <h2 className="mt-5 text-4xl font-semibold leading-[1.1] tracking-tightest text-ink md:text-5xl" data-id="element-56" data-mp="3jdpxhuiis1yt">
                Technology
                <br data-id="element-57" data-mp="387jrmnthkjnb" />
                with purpose.
              </h2>
            </FadeUp>
          </div>

          <div className="space-y-6 text-lg leading-relaxed text-ink/65" data-id="element-58" data-mp="3d0323bwvmynw">
            <FadeUp delay={0.12} data-id="element-59" data-mp="3hyo3henv7odx">
              <p data-id="element-60" data-mp="3hwtjc2kf40aw">
                Haerumbah Pvt. Ltd. is an Indian technology company focused on building products that positively impact people’s everyday lives.
              </p>
            </FadeUp>
            <FadeUp delay={0.18} data-id="element-61" data-mp="2p9zak2wyqpd9">
              <p data-id="element-62" data-mp="2pbabluz0xj0o">
                We believe technology should do more than solve problems — It should create meaningful experiences, encourage healthier lifestyles, strengthen human connections, and make the world a little happier.
              </p>
            </FadeUp>
            <FadeUp delay={0.24} data-id="element-63" data-mp="9htd2yo97wgq">
              <p className="text-ink" data-id="element-64" data-mp="ehe7qwwe5inn">
                Every product we build is guided by a simple long-term vision:
              </p>
            </FadeUp>
            <FadeUp delay={0.3} data-id="element-65" data-mp="2aizi4jq0tjuu">
              <p className="text-2xl font-semibold tracking-tight text-ink" data-id="element-66" data-mp="2amdmtym5q55g">
                HHH — <span className="text-vermillion" data-id="element-67" data-mp="25nk7e0nb842n">Happy</span> ·{' '}
                <span className="text-vermillion" data-id="element-68" data-mp="2jjxp9avra7hn">Healthy</span> ·{' '}
                <span className="text-vermillion" data-id="element-69" data-mp="2fj424jq50wpt">Humanity</span>
              </p>
            </FadeUp>
          </div>
        </div>

        <div className="mt-20 grid gap-px overflow-hidden rounded-2xl border border-black/[0.07] bg-black/[0.07] sm:grid-cols-3" data-id="element-70" data-mp="1ruum5yflv36l">
          {PILLARS.map(({
          icon: Icon,
          title,
          text
        }, i) => <FadeUp key={title} delay={i * 0.08} className="h-full" data-id="element-71" data-mp="20n69hbffaaic" data-mpi={i}>
              <div className="flex h-full flex-col bg-white p-8" data-id="element-72" data-mp="1vv4pf3c0jfhr">
                <Icon className="h-6 w-6 text-vermillion" strokeWidth={1.5} data-id="element-73" data-mp="1vtjxllh32anl" />
                <h3 className="mt-5 text-lg font-semibold tracking-tight text-ink" data-id="element-74" data-mp="184ipy0g2r3jd">
                  {title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-ink/55" data-id="element-75" data-mp="u0jtuolpxzj2">{text}</p>
              </div>
            </FadeUp>)}
        </div>
      </div>
    </section>;
}